var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('a',{attrs:{"href":_vm.link,"title":_vm.title}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.icon)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }